if (!customElements.get('kivo-home-spec-metrics')) {
  customElements.define(
    'kivo-home-spec-metrics',
    class KivoHomeSpecMetrics extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.collapsedCount = Number.parseInt(this.dataset.collapsedCount, 10) || 4;
        this.items = Array.from(this.querySelectorAll('[data-kivo-home-08-metric]'));
        this.button = this.querySelector('[data-kivo-home-08-expand]');
        this.label = this.button?.querySelector('[data-kivo-home-08-expand-label]');
        this.collapsedLabel = this.button?.dataset.collapsedLabel || this.label?.textContent?.trim() || 'LEARN MORE';
        this.expandedLabel = this.button?.dataset.expandedLabel || 'VIEW LESS';
        this.handleToggle = this.handleToggle.bind(this);

        if (!this.button || this.dataset.expanded === 'true') {
          if (this.button) this.button.hidden = true;
          return;
        }

        this.collapseItems();

        this.button.hidden = false;
        this.setExpanded(false);
        this.button.addEventListener('click', this.handleToggle);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.handleToggle);
      }

      handleToggle() {
        const shouldExpand = this.dataset.expanded !== 'true';

        if (shouldExpand) {
          this.showAllItems();
        } else {
          this.collapseItems();
        }

        this.setExpanded(shouldExpand);
      }

      collapseItems() {
        this.items.forEach((item, index) => {
          item.hidden = index >= this.collapsedCount;
        });
      }

      showAllItems() {
        this.items.forEach((item) => {
          item.hidden = false;
          item.classList.remove('is-kivo-home-reveal-queued');
          item.classList.add('is-kivo-home-reveal-visible', 'is-kivo-home-reveal-complete');
        });
      }

      setExpanded(isExpanded) {
        this.dataset.expanded = isExpanded ? 'true' : 'false';
        this.button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        if (this.label) {
          this.label.textContent = isExpanded ? this.expandedLabel : this.collapsedLabel;
        }
      }
    }
  );
}
